import type { HttpClient } from '@remodeling/base';
import {
  GetDisplayInfoRequest,
  GetDisplayInfoResponse,
  GetMenusRequest,
  GetMenusResponse,
  GetSectionMenusResponse,
  GetTemplateInfoRequest,
  GetTemplateInfoResponse,
} from '../../model';

export class GetMenusGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetMenusRequest) {
    return await this.httpClient.request<GetMenusResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-info-service/api/v1/display/menus`,
      body: req,
    });
  }
}

export class GetHamburgerMenusGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetMenusRequest) {
    return await this.httpClient.request<GetSectionMenusResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}/hanssem/display-service/api/v1/menus`,
      body: req,
    });
  }
}

export class GetDisplayInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetDisplayInfoRequest) {
    return await this.httpClient.request<GetDisplayInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/display/display-info`,
      body: req,
    });
  }
}

export class GetTemplateInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetTemplateInfoRequest) {
    return await this.httpClient.request<GetTemplateInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-info-service/api/v1/display/template-info`,
      body: req,
    });
  }
}
